module.exports = __webpack_public_path__ + "static/media/title-speakers.37b7af40.svg";